var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoNumbering(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "auto#"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4 20V9.8C4 8.11984 4 7.27976 4.32698 6.63803C4.6146 6.07354 5.07354 5.6146 5.63803 5.32698C6.27976 5 7.11984 5 8.8 5H13M4 20L2 18M4 20L6 18M4 13L13 13",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "M19.9908 2.50636C19.9908 2.19909 19.7417 1.95 19.4344 1.95C19.3301 1.95 19.2278 1.97935 19.1394 2.0347L18.0954 2.68781C18.0049 2.74439 17.95 2.84355 17.95 2.95022C17.95 3.19322 18.2172 3.34146 18.4234 3.21284L19.2391 2.70397V6.53974C19.2391 6.74732 19.4074 6.91559 19.6149 6.91559C19.8225 6.91559 19.9908 6.74732 19.9908 6.53974V2.50636Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "N_2",
    d: "M21.1301 11.8511L21.1301 11.8506C21.1263 11.0601 20.4306 10.45 19.4687 10.45C18.6281 10.45 17.9553 10.9061 17.8083 11.6259C17.7668 11.8292 17.9408 11.9882 18.1328 11.9882C18.3315 11.9882 18.4759 11.8253 18.5308 11.6533C18.6424 11.3037 18.9668 11.0769 19.4472 11.0742C19.7302 11.0759 19.9757 11.1549 20.1497 11.2905C20.3227 11.4252 20.4267 11.6168 20.4285 11.8508C20.4267 12.0631 20.3572 12.2482 20.211 12.4572C20.0636 12.668 19.8404 12.9002 19.5337 13.2065C19.5337 13.2065 19.5337 13.2065 19.5336 13.2066L17.8605 14.8593C17.7897 14.9292 17.7506 15.0249 17.7522 15.1244C17.7554 15.3232 17.9176 15.4828 18.1165 15.4828H20.9043C21.0804 15.4828 21.2232 15.3401 21.2232 15.164C21.2232 14.9879 21.0804 14.8452 20.9043 14.8452H18.7844L19.926 13.7416L19.926 13.7416C20.8421 12.855 21.1263 12.4185 21.1301 11.8511Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 14,
    cy: 5,
    r: 1,
    stroke: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 14,
    cy: 13,
    r: 1,
    stroke: "#FEFEFE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoNumbering);
export default __webpack_public_path__ + "static/media/auto-numbering.037981e4533907d98ba386e4caea1a8c.svg";
export { ForwardRef as ReactComponent };